import { PolicySectionBorder, PolicySectionTitle } from '@components/privacy'
import markdownStyles from './MarkdownStyles.module.css'

interface TermsOfUseProps {
  content: string
}

export const TermsOfUse = ({ content }: TermsOfUseProps) => {
  return (
    <>
      <PolicySectionTitle>
        <div className="relative">
          <div className="absolute -top-28" id="terms-of-use" />
        </div>
        Terms of use of the Website
      </PolicySectionTitle>

      <div
        className={markdownStyles.markdown}
        dangerouslySetInnerHTML={{ __html: content }}
      />

      <PolicySectionBorder />
    </>
  )
}
